import { useRef } from 'react';
import { useFrame } from '@react-three/fiber';

// CaptureFrameNotifier — praneša TIK po to, kai r3f scena realiai nupiešta IR praėjo
// pakankamai laiko (Canvas'o onCreated iškviečiamas anksčiau, nei suspėjama nupiešti
// pirmą kadrą, o troika-three-text šriftų glifai / tekstūros užsikrauna asinchroniškai,
// tad vien kelių kadrų nepakanka — be šio laiko slenksčio ekrano nuotraukoje dalis
// turinio lieka tuščia). Naudojama off-screen 2D/3D brėžinių fiksavimui (Suvestinė,
// /baldai/:code) — pridedama kaip vaikas TIESIOGIAI po <Canvas>.
const CaptureFrameNotifier = ({ onReady, minFrames = 5, minElapsedMs = 900 }) => {
    const count = useRef(0);
    const startRef = useRef(null);
    const firedRef = useRef(false);
    useFrame(({ gl, clock }) => {
        if (firedRef.current) return;
        if (startRef.current === null) startRef.current = clock.elapsedTime;
        count.current += 1;
        const elapsedMs = (clock.elapsedTime - startRef.current) * 1000;
        if (count.current >= minFrames && elapsedMs >= minElapsedMs) {
            firedRef.current = true;
            onReady?.(gl);
        }
    });
    return null;
};

export default CaptureFrameNotifier;
